import { render, staticRenderFns } from "./HeaderDiploma.vue?vue&type=template&id=14aac2d4"
import script from "./HeaderDiploma.vue?vue&type=script&lang=js"
export * from "./HeaderDiploma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Diplomes3Collone: require('/home/etienne/AM-frontend/components/Diplomes3Collone.vue').default,DiplomesDropDownMenu: require('/home/etienne/AM-frontend/components/DiplomesDropDownMenu.vue').default})
